// extracted by mini-css-extract-plugin
module.exports = {"root":"FormRecoveryLogin_root__2dbNk","title":"FormRecoveryLogin_title__H8nFC","description":"FormRecoveryLogin_description__UUeng"};